import PropTypes from 'prop-types'
import React from 'react'

export default function TimelineItem({
  icon,
  iconType,
  iconColor,
  title,
  description,
  last
}) {
  return (
    <li className="timeline-item">
      {!last && <div className="timeline-tail" />}
      <span className="timeline-icon">
        <box-icon name={icon} color={iconColor} type={iconType} />
      </span>
      <div className="timeline-content">
        <h5 className="font-bold text-black font-inter">{title}</h5>
        <p className="text-gray font-inter">{description}</p>
      </div>
    </li>
  )
}

TimelineItem.propTypes = {
  description: PropTypes.string,
  icon: PropTypes.string,
  iconType: PropTypes.string,
  last: PropTypes.bool,
  title: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/newLayout/components/TimelineItem.js